import { Box, Container, Link, Typography, useTheme } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout } from "@cm-websites/common";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import i18nConfig from "../../next-i18next.config";
import Image from "next/image";
import React from "react";
import Sprachen from "../../public/images/sprachen.jpg";
import type { GetStaticProps } from "next";

export const SprachenPage: NextPageWithLayout = () => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Container maxWidth="md" sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: 4 }}>
        <Typography variant="h1" sx={{ pb: 6 }}>
          Murder Mystery Games in other languages
        </Typography>

        <Typography variant="body1" paragraph>
          Are you looking for a murder mystery in German or French? Our cases have now been published in
          several languages.
        </Typography>
      </Container>
      <Container maxWidth="lg" sx={{ pt: 0, pb: 0 }}>
        <Box>
          <Image
            alt="Murder Mystery Party Games in German, French and Japanes"
            placeholder="blur"
            src={Sprachen}
            title="Murder Mystery Party Games in German, French and Japanes"
            style={{
              borderRadius: theme.shape.borderRadius,
              width: "100%",
              height: "auto",
              overflow: "hidden",
            }}
          />
        </Box>
      </Container>
      <Container maxWidth="md" sx={{ pt: 4, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}>
        <Typography variant="body1" paragraph>
          The following language versions have been published so far (more are planned):
        </Typography>
        <Box component="ul">
          <Typography variant="body1" component="li">
            German: <Link href="https://www.culinario-mortale.de">www.culinario-mortale.de</Link>
          </Typography>

          <Typography variant="body1" component="li">
            French: <Link href="https://www.culinario-mortale.fr">www.culinario-mortale.fr</Link>
          </Typography>

          <Typography variant="body1" component="li">
            Japanese: <Link href="https://www.culinario-mortale.jp">www.culinario-mortale.jp</Link>
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
};

SprachenPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default SprachenPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale
        ? await serverSideTranslations(locale, ["c-common", "c-user-consent-management"], i18nConfig)
        : {}),
    },
  };
};
